import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';

import { getAllKnowledgeRepositoryAction } from '../../Redux/Actions/KnowledgeRepositoryActions';

import PageHeader from '../../Components/PageHeader/PageHeader';
import ProjectCard from '../../Components/ProjectCard/ProjectCard';

const KnowledgeRepository = () => {

    const dispatch = useDispatch()
    const krList = useSelector((e) => e?.KnowledgeRepositoryReducer?.krList)
    const isLoading = useSelector((e) => e?.LoadingReducer?.isLoading)

    useEffect(() => {
        getDetails()
    }, [])

    const getDetails = () => {
        dispatch(getAllKnowledgeRepositoryAction())
    }

    return (
        <>
            <PageHeader
                title="Knowledge Repository"
                breadcrumbs={[
                    { label: 'Home', href: '/' },
                    // { label: 'About', href: '/about' },
                    { label: 'Knowledge Repository' }
                ]}
            />
            <div className="container py-5">

                {
                    isLoading ?
                        <div className='text-center'>
                            <Spinner animation="border" />
                        </div>
                        :

                        <div className="row g-4">
                            {krList?.map((item, index) => (
                                <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={index}>
                                    <div className="card research-card h-100">
                                        <ProjectCard
                                            src={`https://api.coeupdspadelhi.in/uploads/${item?.image}`}
                                            params={item}
                                            path={`knowledgeRepository/${item?.title}`}
                                            title={item.title}
                                        />
                                    </div>
                                </div>
                            ))}

                        </div>
                }

            </div>
        </>
    );
};

export default KnowledgeRepository;